import React, { useState, useLayoutEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import StyleService from '@/services/Style.service';
import { useSnackbar } from 'notistack';
import { Messages } from '@/common/constants';
import Loading from '@/components/common/Loading';
import ConfirmDialog from '@/components/common/ConfirmDialog';
import { Box, Button, Grid } from '@mui/material';
import PageTitle from '@/components/common/PageTitle';
import CommonTableContainer from '@/components/common/CommonTableContainer';
import StyleTableBody from '@/components/styles/StyleTableBody';
import Style from '@/types/Style.type';
import URL from '@/common/routes/Url';

type DeleteType = {
  id: number;
  styleName: string;
};

const StatusList: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [styles, setStyles] = useState<Array<Style>>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState<DeleteType>({ id: 0, styleName: '' });

  const getStyles = useCallback(() => {
    StyleService.getAll()
      .then((response) => {
        setStyles(response.data);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        enqueueSnackbar(Messages.select.failure);
      });
  }, []);

  useLayoutEffect(() => {
    getStyles();
  }, []);

  const deleteStatus = async (id: number) => {
    try {
      await StyleService.delete(id);
    } catch (error: any) {
      enqueueSnackbar(error.response.data.message);
      return;
    }
    enqueueSnackbar(Messages.delete.success, { variant: 'info' });
    getStyles();
  };

  const editStatus = (id: number) => {
    navigate(`${URL.styles}/${id}/`);
  };

  const createStyle = () => {
    navigate(`${URL.styles}/add`);
  };

  const handleDialog = (id: number, styleName: string) => {
    setDeleteInfo({
      id: id,
      styleName: styleName,
    });
    setIsOpen(true);
  };

  const styleTableHeads = ['勤務形態名', 'アイコン', /*'カラー', */'出社日必須', ''];
  const styleTableBody = <StyleTableBody onEdit={editStatus} onDelete={handleDialog} rows={styles} />;

  if (isLoading) {
    return <Loading />;
  }
  return (
    <>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={12} lg={8}>
          <Box sx= {{ display: { xs: 'block', sm: 'none' } }}>
            <PageTitle>勤務形態マスタ</PageTitle>
          </Box>
          <Box sx={{ marginBottom: '16px' }}>
            <Button variant="contained" color="primary" onClick={() => createStyle()}>
              追加画面へ
            </Button>
          </Box>
          <CommonTableContainer tableHeads={styleTableHeads} tableBody={styleTableBody} />
        </Grid>
      </Grid>
      <ConfirmDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onOk={() => {
          setIsOpen(false);
          deleteStatus(deleteInfo.id);
        }}
      >
        {deleteInfo.styleName}を本当に削除しますか？
      </ConfirmDialog>
    </>
  );
};
export default StatusList;
